module.exports = __webpack_public_path__ + "img/polymath.6adcf763.svg";